/**
 * FormProcessHandler, handles the sequential processing of the different form process (onSuccess, onError, Always ..)
 *
 * @typedef {object} FormProcessHandler
 *
 * @param {array} bin the process bin to process
 * @param {object} context the FormController object
 * @returns {FormProcessHandler} the handler
 */
const FormProcessHandler = function (bin, context) {
    this.bin = bin;
    this.binLength = bin.length;
    this.context = context;
    this.index = 0;
};

FormProcessHandler.prototype = {
    /**
     * getNext, return the next chained process function with populated argument
     *
     * @returns {function} the next function call
     */
    getNext() {
        if (this.index < this.binLength) {
            const process = this.bin[this.index];
            this.index++;
            if (typeof process.fnc === 'function') {
                return () => {
                    process.fnc(process.name, this.context.context, this.getNext());
                };
            } else {
                return this.getNext();
            }
        }
        return () => {
            /*must be empty*/
        };
    },
};

export { FormProcessHandler as default };
